// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://etherscan.io/address/0xeBa440B438Ad808101d1c451C1C5322c90BEFCdA
export const POOL_ADDRESSES_PROVIDER = '0xeBa440B438Ad808101d1c451C1C5322c90BEFCdA';

// IPool https://etherscan.io/address/0x0AA97c284e98396202b6A04024F5E2c65026F3c0
export const POOL = '0x0AA97c284e98396202b6A04024F5E2c65026F3c0';

// IPoolConfigurator https://etherscan.io/address/0x8438F4D29D895d75C86BDC25360c25eF0607E65d
export const POOL_CONFIGURATOR = '0x8438F4D29D895d75C86BDC25360c25eF0607E65d';

// IAaveOracle https://etherscan.io/address/0x43b64f28A678944E0655404B0B98E443851cC34F
export const ORACLE = '0x43b64f28A678944E0655404B0B98E443851cC34F';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const ACL_ADMIN = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// IACLManager https://etherscan.io/address/0x3cE8E2eb6501d4705477643E96881B1bef6A2DB3
export const ACL_MANAGER = '0x3cE8E2eb6501d4705477643E96881B1bef6A2DB3';

// IPoolDataProvider https://etherscan.io/address/0x7c8509591f9693D21280d96e149a08A3bf69Cd0c
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x7c8509591f9693D21280d96e149a08A3bf69Cd0c';

// https://etherscan.io/address/0xbe82113a671B69d07dCe65cd30618d315D3D7C34
export const POOL_IMPL = '0xbe82113a671B69d07dCe65cd30618d315D3D7C34';

// https://etherscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://etherscan.io/address/0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb
export const DEFAULT_INCENTIVES_CONTROLLER = '0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb';

// https://etherscan.io/address/0x223d844fc4B006D67c0cDbd39371A9F73f69d974
export const EMISSION_MANAGER = '0x223d844fc4B006D67c0cDbd39371A9F73f69d974';

// ICollector https://etherscan.io/address/0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c
export const COLLECTOR = '0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c';

// https://etherscan.io/address/0xdc7B6B0Acf2FB6927526E2C501De41eaeae8702A
export const DEFAULT_A_TOKEN_IMPL = '0xdc7B6B0Acf2FB6927526E2C501De41eaeae8702A';

// https://etherscan.io/address/0x1D5E86F59069c1AF086607A56d2D7df6f440A5f2
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x1D5E86F59069c1AF086607A56d2D7df6f440A5f2';

// https://etherscan.io/address/0xbaA999AC55EAce41CcAE355c77809e68Bb345170
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xbaA999AC55EAce41CcAE355c77809e68Bb345170';

// https://etherscan.io/address/0x23b282c49C88d9161aae14b5eD777B976A5Ae65D
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x23b282c49C88d9161aae14b5eD777B976A5Ae65D';

// https://etherscan.io/address/0xB04427eFdd15b0EC233400d2F7f7E4fd0291C285
export const SWAP_COLLATERAL_ADAPTER = '0xB04427eFdd15b0EC233400d2F7f7E4fd0291C285';

// https://etherscan.io/address/0x850347E0cF64fd342A3404c1c5DA21Aa0A46c5c6
export const WITHDRAW_SWAP_ADAPTER = '0x850347E0cF64fd342A3404c1c5DA21Aa0A46c5c6';

// https://etherscan.io/address/0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047
export const UI_INCENTIVE_DATA_PROVIDER = '0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047';

// https://etherscan.io/address/0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978
export const UI_POOL_DATA_PROVIDER = '0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978';

// https://etherscan.io/address/0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2
export const WALLET_BALANCE_PROVIDER = '0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2';

// https://etherscan.io/address/0xf956B38F035dC9067fb827A512D3CF35202AB0Bc
export const WETH_GATEWAY = '0xf956B38F035dC9067fb827A512D3CF35202AB0Bc';

// https://etherscan.io/address/0xfa4B5444cbB90f19f1C28FcE63924013C84140D9
export const CONFIG_ENGINE = '0xfa4B5444cbB90f19f1C28FcE63924013C84140D9';

// https://etherscan.io/address/0xBF79d8339303148E345277a994Eb2cD5d82F0067
export const RISK_STEWARD = '0xBF79d8339303148E345277a994Eb2cD5d82F0067';

// https://etherscan.io/address/0x40ede12b44d98Fc4E53A2fB027D1BD1846e1690C
export const DEBT_SWAP_ADAPTER = '0x40ede12b44d98Fc4E53A2fB027D1BD1846e1690C';

// https://etherscan.io/address/0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b
export const DUST_BIN = '0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b';

export const CHAIN_ID = 1;
export const ASSETS = {
  weETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
    A_TOKEN: '0xbe1F842e7e0afd2c2322aae5d34bA899544b29db',
    V_TOKEN: '0x16264412CB72F0d16A446f7D928Dd0D822810048',
    INTEREST_RATE_STRATEGY: '0xC16666b7FF197427BD255E6961A5F99cfb3A6059',
    ORACLE: '0xf112aF6F0A332B815fbEf3Ff932c057E570b62d3',
  },
  USDC: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    A_TOKEN: '0x7380c583cDe4409eFF5DD3320D93a45D96B80E2e',
    V_TOKEN: '0x9355032d747f1e08F8720CD01950E652eE15cdB7',
    INTEREST_RATE_STRATEGY: '0xC16666b7FF197427BD255E6961A5F99cfb3A6059',
    ORACLE: '0xB6557F02F0a5dA7b9D3C2d979cc19e00e756F6dA',
  },
  PYUSD: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8',
    A_TOKEN: '0xdF7f48892244C6106EA784609f7de10AB36F9c7e',
    V_TOKEN: '0xD2cf07dEE40d3D530D15b88d689f5cd97A31FC3D',
    INTEREST_RATE_STRATEGY: '0xC16666b7FF197427BD255E6961A5F99cfb3A6059',
    ORACLE: '0x36964C0579D02E0a5AaAb89E24Cf8d7CDF3549EE',
  },
  FRAX: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x853d955aCEf822Db058eb8505911ED77F175b99e',
    A_TOKEN: '0x6914ECCf50837dC61b43ee478a9BD9B439648956',
    V_TOKEN: '0xfd3aDA5AAbdc6531C7C2AC46c00eBf870f5a0E6B',
    INTEREST_RATE_STRATEGY: '0xC16666b7FF197427BD255E6961A5F99cfb3A6059',
    ORACLE: '0xeF50f8DC65402c3019586bc8725fCD0b99B8AAd7',
  },
} as const;
export const E_MODES = {} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
